import { ImageInput } from 'components/ImageInput/ImageInput';
import s from './BlogCard.module.scss';
import { format } from 'date-fns';
import { DateFormat } from 'utils/enums/common.enum';
import { clearHTML } from 'utils/clearHTML';

export const BlogCard = ({image, setForm, title, body, date}: any) => {

    // ### State

    // ### Effects

    // ### Functions

    // ### Views
    
    return(
        <div className={s.card}>
            <div className={s.image_wrapper}>
                <ImageInput 
                    values={image}
                    setValues={(value: any) => {
                        setForm((prev: any) => ({
                            ...prev,
                            image: {...prev.image, ...value}
                        }))
                    }}
                    setIsManual={(value: any) => {
                        setForm((prev: any) => ({
                            ...prev,
                            image: {...prev.image, isManual: value}
                        }))
                    }}
                    setDefault={(value: any) => {
                        setForm((prev: any) => ({
                            ...prev,
                            image: {...prev.image, default_image: value}
                        }))
                    }}
                />
            </div>
            <div className={s.content}>
                {date ? <span className={s.date}>{format(new Date(date), DateFormat.SHORT)}</span> : null}
                {title ? <p className={s.title}>{clearHTML(title)}</p> : null}
                {body ? <p className={s.body}>{clearHTML(body)}</p> : null}
            </div>
        </div>
    )
}